import { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import { useRouter } from 'next/router'
import { useLazyQuery } from '@apollo/client'
import { generatePath } from '@/lib/urlParse'
import QUERY_PROPERTY_LIST from '../../graphqls/queryPropertyList.gql'
import { statsigLog } from '../../lib/statsigAndGa'

const Search = ({ locationName = '', city = '', area = '' }) => {
  const router = useRouter()
  const [isShadow, setIsShadow] = useState(false)
  const [count, setCount] = useState(0)

  const [queryLsat] = useLazyQuery(QUERY_PROPERTY_LIST, {
    onCompleted: ({ queryRentyAIProperties }) => {
      const { pageInfo } = queryRentyAIProperties || {}
      const { total = 0 } = pageInfo || {}
      setCount(total)
    }
  })

  const handleToSearch = () => {
    statsigLog('market_trend_side_bar_click', {
      city,
      region: area
    })
    const path = generatePath(city, area)
    router.push(path)
  }

  useEffect(() => {
    const { innerWidth } = window
    setIsShadow(innerWidth < 1179)
    queryLsat({
      variables: {
        filterBy: {
          areaEqualTo: area || null,
          cityEqualTo: city || null,
          isColiving: null,
          isRentOutStatus: true
        },
        pageNum: 1,
        pageSize: 1
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      className="p-5 lg:p-4 bg-white text-primary fixed z-10 rounded-t-3xl lg:rounded-l-2xl lg:rounded-r-none right-0 bottom-0 lg:bottom-[unset] w-full lg:w-auto lg:border lg:border-[#E0E2EF] text-left lg:text-center"
      style={{
        boxShadow: isShadow ? '3px 12px 27px 0px rgba(36, 42, 46, 0.50)' : 'none'
      }}
    >
      <div className="flex items-start mb-4">
        <LocationOnIcon className="text-base h-6 text-[#75798D] mr-1" />
        <div className="text-left">
          <div className="text-base font-semibold">{locationName}</div>
          <div className="text-xs">{count.toLocaleString('en')} available apartments for rent</div>
        </div>
      </div>

      <Button
        className="px-6 py-2 rounded-lg bg-brand w-full lg:w-auto text-center"
        onClick={handleToSearch}
      >
        <span className="text-white font-semibold capitalize text-sm">Search for Apartments</span>
      </Button>
    </div>
  )
}

export default Search
